import React from 'react';
import { Link } from 'react-router-dom';
import { Field,  reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, FormActions, Select, HtmlEditor, Checkbox } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import Localizations from '../localization';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, grades, initialValues, t, lang }) => {
	const id = initialValues ? initialValues.id : 0;
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Select name='gradeId' data={grades} horizontal required label={t('WeeklyInformation_Grade')} validate={validators.required} />
			<Field name='weekNumber' component={Input} disabled={isReadonly} horizontal required type='text' label={t('WeeklyInformation_WeekNumber')} validate={[validators.required, validators.number]} />
			<Field name='isOnline' component={Checkbox} disabled={isReadonly} horizontal label={t('WeeklyInformation_IsOnline')} normalize={(v) => { return !!v }} />
			<Field name='description' component={HtmlEditor} disabled={isReadonly} lang={lang} horizontal type='text' label={t('WeeklyInformation_Description')} />
			{id > 0 && <Localizations entityId={id} rootName={'weeklyInformations'} propertyName={'Description'} label={t('WeeklyInformation_Description')} resourceName={`WeeklyInformation.${id}.Description`} isHtml={true} isReadonly={isReadonly}/>}
			<FormActions horizontal>
				<Link to='/weeklyInformations' className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'weeklyInformation', enableReinitialize: true })(withTranslation()(SettingsForm));
